import { render, staticRenderFns } from "./product-manager.vue?vue&type=template&id=8f512b66&scoped=true&"
import script from "./product-manager.vue?vue&type=script&lang=js&"
export * from "./product-manager.vue?vue&type=script&lang=js&"
import style0 from "./product-manager.vue?vue&type=style&index=0&id=8f512b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f512b66",
  null
  
)

export default component.exports